import React from "react";
import InfiniteScroll from "react-infinite-scroller";

import { getFavoriteCars, removeFavoriteCar } from "../../model/car";

import { commonErr } from "../common/errors";
import { stypes } from "../common/common";

import { LoadingPage } from "../common/loading";
import { Empty } from "../common/messagebox";

import Header from "../components/header";
import Footer from "../components/footer";
import Session from "../common/session";
import AccountSideBar from "./components/accountsidebar";
import CarItemMyFavs from "../common/caritemmyfavs";

import empty from "../../static/images/empty/empty-favcar.svg";

const MyFavsBar = ({ mode, viewSDFavs, viewWDFavs }) => {
	return (
		<div className="tab-mode">
			<div className={`tab-mode__item ${mode === stypes.SD ? "active" : ""}`} onClick={viewSDFavs}>
				Xe tự lái
			</div>
			<div className={`tab-mode__item ${mode === stypes.WD ? "active" : ""}`} onClick={viewWDFavs}>
				Xe có tài xế
			</div>
		</div>
	);
};

class MyFavs extends React.Component {
	constructor() {
		super();
		this.state = {
			cars: [],
			more: 0,
			mode: 1,
			err: commonErr.INNIT,
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.setState({
			err: commonErr.LOADING,
		});

		this.getFavsFirstAndMore(this.state.mode);
	}

	removeFromFavorites = (carId, mode) => {
		removeFavoriteCar(carId, mode).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS) {
				this.setState({
					buttonState: 0,
				});
			}
			var cars = this.state.cars.filter((car) => {
				return car.id !== carId;
			});
			this.setState({
				cars: cars,
			});
		});
	};

	viewSelfDriveFavs = () => {
		this.setState({
			err: commonErr.LOADING,
		});
		this.setState(
			{
				mode: stypes.SD,
				cars: [],
			},
			() => {
				this.getFavsFirstAndMore(stypes.SD);
			}
		);
	};

	viewWithDriverFavs = () => {
		this.setState({
			err: commonErr.LOADING,
		});
		this.setState(
			{
				mode: stypes.WD,
				cars: [],
			},
			() => {
				this.getFavsFirstAndMore(stypes.WD);
			}
		);
	};

	getFavsFirstAndMore = (mode) => {
		getFavoriteCars(0, this.state.cars.length, 0, mode).then((resp) => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data) {
				this.setState({
					cars: this.state.cars.concat(resp.data.data.cars),
					more: resp.data.data.more,
					err: resp.data.error,
				});
			} else {
				this.setState({
					more: 0,
					err: resp.data.error,
				});
			}
		});
	};

	render() {
		var favoritesCont;

		if (this.state.err === commonErr.LOADING) {
			favoritesCont = <LoadingPage />;
		} else {
			const favorites = this.state.cars;

			if (favorites[0]) {
				favoritesCont = (
					<InfiniteScroll
						pageStart={0}
						loadMore={() => {
							this.getFavsFirstAndMore(this.state.mode);
						}}
						hasMore={this.state.more === 1}
						loader={<div key={0}></div>}
						useWindow={true}>
						<div className="list-car fav-car">
							{favorites.map((car) => (
								<CarItemMyFavs
									key={car.id}
									removeFromFavorites={this.removeFromFavorites}
									car={car}
									mode={this.state.mode}
								/>
							))}
						</div>
					</InfiniteScroll>
				);
			} else {
				favoritesCont = <Empty msg={"Không có xe yêu thích"} img={empty} />;
			}
		}

		return (
			<div className="mioto-layout">
				<Session />
				<Header />
				<section className="body">
					<div className="account-section sec space">
						<div className="m-container">
							<div className="account-container">
								<AccountSideBar />
								<div className="content-account">
									<div className="content-title">
										<h4>Xe yêu thích của tôi</h4>
									</div>
									<MyFavsBar
										mode={this.state.mode}
										viewSDFavs={this.viewSelfDriveFavs}
										viewWDFavs={this.viewWithDriverFavs}
									/>
									{favoritesCont}
								</div>
							</div>
						</div>
					</div>
				</section>
				<Footer />
			</div>
		);
	}
}

export default MyFavs;
